import { io } from 'socket.io-client';

const URL = process.env.NODE_ENV === 'production'
  ? 'https://arcticphone-server.onrender.com'
  : 'http://localhost:5001';

// Anonymous, silent per-install id sent on the handshake. NOT an account — no
// PII, no login, never shown to the user. Persisted in localStorage so it
// survives reloads and new tabs, giving the operator a durable handle to block a repeat
// abuser without forcing logins on the 99.9% who never misbehave.
function getInstallId() {
  try {
    let id = localStorage.getItem('pictaphone_install_id');
    if (!id) {
      id = (window.crypto && crypto.randomUUID)
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      localStorage.setItem('pictaphone_install_id', id);
    }
    return id;
  } catch {
    return undefined;  // private mode / storage blocked — just skip the handle
  }
}

export const socket = io(URL, {
  autoConnect: true,
  transports: ['websocket', 'polling'],
  auth: { installId: getInstallId(), platform: 'web' },
});
